export enum PermissionNames {
  // Admin Module Permissions (Available to both Host and Tenant)
  ADMIN = 'Admin',

  // Admin Roles Permissions
  ADMIN_ROLES = 'Admin.Roles',
  ADMIN_ROLES_CREATE = 'Admin.Roles.Create',
  ADMIN_ROLES_UPDATE = 'Admin.Roles.Update',
  ADMIN_ROLES_DELETE = 'Admin.Roles.Delete',
  ADMIN_ROLES_VIEW = 'Admin.Roles.View',

  // Admin User Permissions
  ADMIN_USER = 'Admin.User',
  ADMIN_USER_CREATE = 'Admin.User.Create',
  ADMIN_USER_UPDATE = 'Admin.User.Update',
  ADMIN_USER_DELETE = 'Admin.User.Delete',
  ADMIN_USER_VIEW = 'Admin.User.View',

  // Admin Permission Management
  ADMIN_PERMISSION = 'Admin.Permission',
  ADMIN_PERMISSION_VIEW = 'Admin.Permission.View',

  // Admin Dashboard
  ADMIN_DASHBOARD = 'Admin.Dashboard',

  // Admin Tenant Management
  ADMIN_TENANT_MANAGEMENT = 'Admin.TenantManagement',
  ADMIN_TENANT_MANAGEMENT_CREATE = 'Admin.TenantManagement.Create',
  ADMIN_TENANT_MANAGEMENT_VIEW = 'Admin.TenantManagement.View',

  // Admin Subscription Management
  ADMIN_SUBSCRIPTION_MANAGEMENT = 'Admin.SubscriptionManagement',
  ADMIN_SUBSCRIPTION_MANAGEMENT_PLANS = 'Admin.SubscriptionManagement.Plans',
  ADMIN_SUBSCRIPTION_MANAGEMENT_WORQUA = 'Admin.SubscriptionManagement.Worqua',

  // Admin Settings Management
  ADMIN_SETTINGS_MANAGEMENT = 'Admin.SettingsManagement',
  ADMIN_SETTINGS_MANAGEMENT_LIST = 'Admin.SettingsManagement.List',
  ADMIN_SETTINGS_MANAGEMENT_PERMISSIONS = 'Admin.SettingsManagement.Permissions',
  ADMIN_SETTINGS_MANAGEMENT_TENANT_USERS = 'Admin.SettingsManagement.TenantUsers',

  // Admin Payment Management
  ADMIN_PAYMENT_MANAGEMENT = 'Admin.PaymentManagement',

  // Admin Environment Management
  ADMIN_ENVIRONMENT_MANAGEMENT = 'Admin.EnvironmentManagement',

  // Admin Email Management
  ADMIN_EMAIL_MANAGEMENT = 'Admin.EmailManagement',
  ADMIN_EMAIL_MANAGEMENT_LOGS = 'Admin.EmailManagement.Logs',

  // Master Module Permissions (Host only)
  MASTER = 'Master',

  // Master Tenants Permissions
  MASTER_TENANTS = 'Master.Tenants',
  MASTER_TENANTS_CREATE = 'Master.Tenants.Create',
  MASTER_TENANTS_UPDATE = 'Master.Tenants.Update',
  MASTER_TENANTS_DELETE = 'Master.Tenants.Delete',
  MASTER_TENANTS_VIEW = 'Master.Tenants.View',

  // Master Stores Permissions
  MASTER_STORES = 'Master.Stores',
  MASTER_STORES_CREATE = 'Master.Stores.Create',
  MASTER_STORES_UPDATE = 'Master.Stores.Update',
  MASTER_STORES_DELETE = 'Master.Stores.Delete',
  MASTER_STORES_VIEW = 'Master.Stores.View',

  // Dashboard Master Permission (Host only)
  DASHBOARD_MASTER = 'Master.Dashboard',

  // ✅ New fields
  ADMIN_REPORTS = 'Admin.Reports',
  ADMIN_REPORTS_VIEW = 'Admin.Reports.View',
  ADMIN_AUDIT_LOGS = 'Admin.AuditLogs',
  ADMIN_AUDIT_LOGS_VIEW = 'Admin.AuditLogs.View',

  // ✅ Prospects Management
  ADMIN_PROSPECTS_MANAGEMENT = 'Admin.ProspectsManagement',
  ADMIN_PROSPECTS_MANAGEMENT_LIST = 'Admin.ProspectsManagement.List',
  ADMIN_PROSPECTS_MANAGEMENT_VIEW = 'Admin.ProspectsManagement.View',
  ADMIN_PROSPECTS_MANAGEMENT_DELETE = 'Admin.ProspectsManagement.Delete',
  Admin_ProspectsManagement_Create = "Admin.ProspectsManagement.Create",
  ADMIN_PROSPECTS_MANAGEMENT_CONVERT = 'Admin.ProspectsManagement.Convert',
  ADMIN_PROSPECTS_MANAGEMENT_UPDATE = 'Admin.ProspectsManagement.Update',

  // Environment Configuration
  ADMIN_ENVIRONMENT_CONFIG = 'Admin.EnvironmentConfiguration',
}
